import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { testimonials } from '../../data/testimonials';
import { SectionHeading } from '../ui/SectionHeading';
export function Testimonials() {
  const {
    t,
    b
  } = useLanguage();
  const [index, setIndex] = useState(0);
  const active = testimonials[index];
  const go = (delta: number) => setIndex(current => (current + delta + testimonials.length) % testimonials.length);
  return <section className="bg-navy py-20 md:py-24" aria-labelledby="testimonials-title" data-id="element-371" data-mp="91mizbgmcwsd">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8" data-id="element-372" data-mp="e1imzapbgo7x">
        <SectionHeading id="testimonials-title" title={t('testimonials.title')} subtitle={t('testimonials.sub')} tone="dark" data-id="element-373" data-mp="dywcb274pslh" />

        <div className="relative mx-auto mt-14 max-w-3xl" data-id="element-374" data-mp="2fsvnlnk949y6">
          <QuoteIcon className="mx-auto h-9 w-9 text-cta-light" aria-hidden="true" data-id="element-375" data-mp="1sl2odziug025" />
          <AnimatePresence mode="wait" data-id="element-376" data-mp="1nu2qos1whdyl">
            <motion.figure key={active.id} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-6 text-center" data-id="element-377" data-mp="1nt135o3p6yzz">
              <div className="flex justify-center gap-1" role="img" aria-label={t('testimonials.rating')} data-id="element-378" data-mp="2bilvuypnlamg">
                {Array.from({
                length: 5
              }).map((_, star) => <StarIcon key={star} className="h-5 w-5 fill-[#F5C518] text-[#F5C518]" aria-hidden="true" data-id="element-379" data-mp="22hnoc6g0akz4" data-mpi={star} />)}
              </div>
              <blockquote className="mt-6 text-lg font-medium italic leading-relaxed text-white md:text-xl" data-id="element-380" data-mp="1xlym1vclqpz4">
                “{b(active.quote)}”
              </blockquote>
              <figcaption className="mt-7 flex flex-col items-center gap-2" data-id="element-381" data-mp="m35pfr346309">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/10 font-display text-sm font-bold text-white" data-id="element-382" data-mp="nmnrvyreb23d">
                  {active.initials}
                </span>
                <span className="font-display text-base font-bold text-white" data-id="element-383" data-mp="ekel9jz8zsv9">{active.name}</span>
                <span className="text-sm text-white/60" data-id="element-384" data-mp="ikyh8k834qft">
                  {active.location} · {b(active.service)}
                </span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>

          <div className="mt-10 flex items-center justify-center gap-4" data-id="element-385" data-mp="9nxxiqvyngip">
            <button type="button" onClick={() => go(-1)} aria-label={t('testimonials.prev')} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 ease-smooth hover:bg-white hover:text-navy" data-id="element-386" data-mp="3r3nuik2j2kjq">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-387" data-mp="33ey380vtadj2" />
            </button>
            <div className="flex gap-2" data-id="element-388" data-mp="33gsmzbvcjzlk">
              {testimonials.map((item, dot) => <button key={item.id} type="button" onClick={() => setIndex(dot)} aria-label={`${item.name}, ${item.location}`} aria-current={dot === index} className={['h-2.5 rounded-full transition-[width,background-color] duration-200 ease-smooth', dot === index ? 'w-7 bg-cta-light' : 'w-2.5 bg-white/30 hover:bg-white/60'].join(' ')} data-id="element-389" data-mp="2yi7nxfrtzlyp" data-mpi={dot} />)}
            </div>
            <button type="button" onClick={() => go(1)} aria-label={t('testimonials.next')} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 ease-smooth hover:bg-white hover:text-navy" data-id="element-390" data-mp="3r5v48im2jqfj">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-391" data-mp="1ye87by6aqz94" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}